import React from "react";
import { AppContext } from "../AppContext.js";
import { BaseInquiryToolBar, BaseNodeBar, BaseToolBar, ModuleToolBar, } from "./BaseModule.js";
import {
  NEW_ENTRY,
} from "../ds/App_Constants.js";
import {
  RestReadRequest,
  CriticalPathManagementBean, RestPageListBean, CustomerSearchCriteria, RestCustomerListRequest, SalesOrderSearchCriteria, RestSalesOrderListRequest, PageListBean, PickTicketSearchCriteria,
  RestPickTicketListRequest, LogisticOrderSearchCriteria, RestLogisticOrderListRequest, RestLogisticOrderReceiptListRequest, LogisticOrderReceiptSearchCriteria,
  RestCriticalPathManagementOperationRequest, CriticalPathManagementSearchCriteria, RestCriticalPathManagementListRequest, CriticalPathManagementLineBean, ReasonBean
} from "../ds/ds.js";
import CustomTable from "../gui_components/CustomTable.js";
import { CustomerService } from "../services/CustomerService.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toFormattedDate_v1
} from "../gui_components/Util.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DatePickerComponent,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  TimePickerComponent,
} from "../gui_components/UIComponents.js";
import { Button, Col, FormLabel, Row, Table,  FormControl, } from "react-bootstrap";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler";
import { SalesOrderLookupHandler } from "../lookup/SalesOrderLookupHandler.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import { PickTicketLookupHandler } from "../lookup/PickTicketLookupHandler.js";
import { PickTicketService } from "../services/PickTicketService.js";
import { LogisticOrderService } from "../services/LogisticOrderService.js";
import { LogisticOrderLookupHandler } from "../lookup/LogisticOrderLookupHandler.js";
import { LogisticReceiptLookupHandler } from "../lookup/LogisticReceiptLookupHandler.js";
import { LogisticOrderReceiptService } from "../services/LogisticOrderReceiptService.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CPMRestService } from "../services/CPMRestService.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import { CpmLookupHandler } from "../lookup/CpmLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { ModuleUtils } from "./ModuleUtils.js";
import { ConfigManager } from "../config/ConfigManager.js";
class Cpm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Critical Path Management",
      isLoading: false,
      isShowModuleSearchContainer: false,
      isMaintenanceMode: true,
      moduleKeyCode: "NEW",
      disabled: false,
      isSpecialViewMode: false,
      isResetView: true,
      isFocusLookup: true,
      CpmLookupHandler: null,
      isCpmEntryFormOpen: false,
      isCpmListFormOpen: true,
      pageList: new RestPageListBean(),
      cpmDataBean: new CriticalPathManagementBean(),
      customerLookupHandler: null,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: null,
      salesOrderListForAutoCompleteList: new Array(),
      showAutoCompleteSalesOrderList: true,
      salesOrderLookupHandler: null,
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      pickTicketPageListForAutoCompleteList: new Array(),
      showAutoCompletePTList: true,
      pickTicketLookupHandler: null,
      logisticOrderLookupHandler: null,
      showAutoCompleteLogisticOrderNumberList: true,
      logisticOrderNumberListForAutoCompleteList: new Array(),

      showAutoCompleteLogisticOrderReceiptNumberList: true,
      logisticReceiptOrderListForAutoCompleteList: new Array(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isViewMode: false,
      isDisabledFields: false,
      logisticReceiptLookupHandler: null,
      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      error_list: [],
      criteria: new CriticalPathManagementSearchCriteria(),
      cpmListData: [],

      templateLookUpHandle: null,
      showAutoCompleteTemplateList: true,
      templateCodePageListForAutoCompleteList: new Array(),
      templateList: [],
      isShowLinePopup: false,
      isShowAlertLvl1: false,
      cpmLineData: new CriticalPathManagementLineBean(),
      is3PL: false,
      previousValue: "",


    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...this.cache };
    this.moduleCaption = "Critical Path Management";
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    ModuleUtils.getCpmStatusList();
    ModuleUtils.cpmLinesStatusList();
    this.state.criteria = new CriticalPathManagementSearchCriteria();
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new RestPageListBean();
    this.state.pageList.pageSize = 10;
    let cpmTemplates = attribute_cache.cpmTemplates;
    if (cpmTemplates != null || cpmTemplates != undefined) {
      cpmTemplates.map((attr) => {
        this.state.templateList.push(attr);
      });
    }
    this.initLookupHandlers();
    // this.addNewEntry();
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;

    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });

    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      this.editCpm(this.props.code);

      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
    }

  }
  initLookupHandlers = () => {
    let cpmLookupHandler = new CpmLookupHandler(
      this.companyCode,
      "CPM"
    );
    this.setState({ cpmLookupHandler: cpmLookupHandler });
    const customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode"
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
    let salesOrderLookupHandler = new SalesOrderLookupHandler(
      this.companyCode,
      "SalesOrderNumber"
    );
    this.setState({ salesOrderLookupHandler: salesOrderLookupHandler });
    let pickTicketLookupHandler = new PickTicketLookupHandler(
      this.companyCode,
      "pickTicketNumber"
    );
    this.setState({ pickTicketLookupHandler: pickTicketLookupHandler });

    let logisticOrderLookupHandler = new LogisticOrderLookupHandler(
      this.companyCode,
      "inBoundOrderNumber"
    );
    this.setState({ logisticOrderLookupHandler: logisticOrderLookupHandler });

    let logisticReceiptLookupHandler = new LogisticReceiptLookupHandler(
      this.companyCode,
      "inBoundOrderReceiptNumber"
    );
    this.setState({ logisticReceiptLookupHandler: logisticReceiptLookupHandler });

    let templateLookUpHandle = new GenericAttributeLookupHandler(
      this.state.templateList,
      "templateCode"
    );
    this.setState({ templateLookUpHandle: templateLookUpHandle });
  };
  addNewEntry = () => {
    let cpmBean = new CriticalPathManagementBean();
    cpmBean.companyCode = this.companyCode;
    cpmBean.cpmStatus = LogicConstants.CRITICAL_PATH_MANAGEMENT_OPEN_STATUS;
    cpmBean.templateCode = ConfigManager.isCpmDefaultTemplateCode();
    if (!isEmpty(cpmBean.templateCode)) {
      this.readTemplateCode(cpmBean.templateCode);
    }
    cpmBean.cpmDate = toFormattedDate_v1(new Date());
    let pageTitle = this.moduleCaption + " - NEW";
    if (!isEmptyString(this.state.moduleKeyCode)) {
      cpmBean.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    } else cpmBean.code = NEW_ENTRY;
    this.setState({
      cpmDataBean: cpmBean,
      isCpmListFormOpen: false,
      pageTitle: pageTitle,
      isLoading: false,

    });
    this.state.isDisabledFields = false;
    this.state.cpmDataBean = cpmBean;
    this.openEntryForm();
  };
  openEntryForm = () => {
    this.setState({
      isCpmEntryFormOpen: true,
      isCpmListFormOpen: false,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isResetView: false,
      isShowModuleSearchContainer: true,
      isDisabledFields: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        disabled: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          disabled: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        isDisabledFields: true,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    let cpmBean = this.state.cpmDataBean;
    if (cpmBean) {
      if (
        cpmBean.cpmStatus ==
        LogicConstants.CRITICAL_PATH_MANAGEMENT_UNAPPROVE_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: true,
          isShowApproveButton: true,
          isShowSaveButton: true,
          isShowExcelButton: true,

        });
      }
      if (
        cpmBean.cpmStatus ==
        LogicConstants.CRITICAL_PATH_MANAGEMENT_OPEN_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: true,
          isShowCancelButton: true,
          isShowApproveButton: false,
          isShowSaveButton: true,
          isDisabledFields: false,

        });
      }
      if (
        cpmBean.cpmStatus ==
        LogicConstants.CRITICAL_PATH_MANAGEMENT_CLOSE_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: true,
          isShowCancelButton: true,
          isShowApproveButton: false,
          isShowSaveButton: false,
          isDisabledFields: true,
          isShowCancelButton: false,
        });
      }
    }
  }
  moduleExit = () => {
    let cpmDataBean = this.state.cpmDataBean;
    if (cpmDataBean.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (!this.state.isViewMode && this.isLocked)
        this.unlockCpm(cpmDataBean.code);
      this.props.onModuleExit();
    }

  };
  resetView = () => {
    let cpmDataBean = this.state.cpmDataBean;

    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unlockCpm(cpmDataBean.code);
    } else {
      this.isLocked = false;
    }
    let cpmData = new CriticalPathManagementBean();

    this.setState({
      cpmDataBean: cpmData,
      isShowModuleSearchContainer: true,
      isDisabledFields: false,
      moduleKeyCode: "NEW",
      isFocusLookup: true,
      isCpmEntryFormOpen: true,
      isCpmListFormOpen: false,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      previousValue: "",

    })
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.addNewEntry();
    this.hideAlertCallBack();
  }
  editCpm = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    let isLockRequired = NEW_ENTRY === code ? false : true;
    readrestInput.isLockRequired = isLockRequired;
    this.setState({
      isLoading: true,
      loadingText: "Loading..",
    });
    if (SecurityAccessManager.CriticalPathManagementView_IsAccessible) {
      CPMRestService.initCriticalPathManagementModule(
        readrestInput,
        this.editCpmResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
      });
    }
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  editCpmResponse = (response) => {
    let dependenciesBean = null;
    if (response.data.cpmDependenciesBean != null) {
      dependenciesBean = response.data.cpmDependenciesBean;
    }
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.cpmResponseBean != null) {
      let cpmBean = response.data.cpmResponseBean.cpmBean;
      if (cpmBean != null) {

        let pageTitle = this.moduleCaption + " - EDIT";
        let moduleKeyCode = cpmBean.code;

        this.setState({
          cpmDataBean: cpmBean,

          pageTitle: pageTitle,
          isFocusLookup: false,
          isFocus: true,
          moduleKeyCode: moduleKeyCode,
          isLoading: false,
        });
        this.isLocked = true;

        this.openEntryForm();

      } else {
        this.addNewEntry();
      }
    }
    this.setState({
      isLoading: false,
    });
  }
  selectButtonClick = (e) => {
    this.editCpm(this.state.moduleKeyCode);
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  getModuleListView = () => {

    let cpmDataBean = this.state.cpmDataBean;
    if (cpmDataBean.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadCPMPage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockCpm(cpmDataBean.code);
      } else {
        this.isLocked = false;
      }
      this.closeEntryForm();
      this.loadCPMPage();
    }


    // let cpmDataBean = this.state.cpmDataBean;
    // if (cpmDataBean.code === NEW_ENTRY) {
    //   this.closeEntryForm();
    //   this.loadCPMPage();
    // } else {
    //   if (!this.state.isViewMode && this.isLocked)
    //     this.unlockCpm(cpmDataBean.code);

    //   this.closeEntryForm();
    //   this.loadCPMPage();
    // }

  };
  closeEntryForm = () => {
    this.setState({
      isShowModuleSearchContainer: false,
      moduleKeyCode: "NEW",
      isFocusLookup: true,
      isCpmEntryFormOpen: false,
      isCpmListFormOpen: true,
      isMaintenanceMode: false,
      isViewMode: false,
      isSpecialViewMode: false,
      isResetView: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
    })
  };
  loadCPMPage = () => {
    let requestInput = new RestCriticalPathManagementListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.criteria = this.state.criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.CriticalPathManagementMaintainance_IsAccessible()) {
      CPMRestService.getCriticalPathManagementPageList(
        requestInput,
        this.loadCpmPageListResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }
  loadCpmPageListResponse = (response) => {
    if (response.data != null && response.data.cpmPageList != null) {
      if (!isEmptyArray(response.data.cpmPageList.cpmBean)) {
        const cpmListData =
          response.data.cpmPageList.cpmBean;
        let pageList = this.state.pageList;
        // pageList.totalCount = response.data.cpmPageList.totalCount;
        // pageList.currentPage = response.data.cpmPageList.currentPage;

        pageList.totalCount =
          response.data.cpmPageList.totalCount;
        pageList.currentPage =
          response.data.cpmPageList.currentPage;
        this.setState({
          isLoading: false,
          cpmListData: cpmListData,
          pageList: pageList,
        });
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  filterCpm = () => {
    this.loadPage(1);
  };
  resetCpm = (criteria) => {
    criteria = new CriticalPathManagementSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  searchOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = pageNumber;
    if (pageList != null) { pageInput.totalCount = pageList.totalCount }
    this.state.pageList = pageInput;
    this.loadCPMPage();
  };


  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.cpmDataBean;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let cpmDataBean = this.state.cpmDataBean;
      cpmDataBean.customerCode = "";
      cpmDataBean.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        cpmDataBean: cpmDataBean,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ cpmDataBean: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let cpmDataBean = this.state.cpmDataBean;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;

      if (!isEmpty(customerData)) {
        cpmDataBean.customerName = customerData.description;
        cpmDataBean.customerCode = customerData.code;
        this.setState({
          cpmDataBean: cpmDataBean,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  //
  salesOrderOnChange = (e) => {
    let salesOrderNumber = e.target.value;
    this.state.showAutoCompleteSalesOrderList = true;
    let tempCriteria = this.state.cpmDataBean;
    let showAutoCompleteList = this.state.showAutoCompleteSalesOrderList;
    if (isEmpty(salesOrderNumber)) {
      this.state.showAutoCompleteSalesOrderList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesOrderList;
      let cpmDataBean = this.state.cpmDataBean;
      cpmDataBean.salesOrderNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteSalesOrderList: showAutoCompleteList,
        cpmDataBean: cpmDataBean,
        salesOrderListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "salesOrderNumber" &&
      showAutoCompleteList === true &&
      salesOrderNumber !== ""
    ) {
      this.readSalesOrderBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ cpmDataBean: tempCriteria });
  };
  readandsetSalesOrderDetailResponse = (response) => {
    let cpmDataBean = this.state.cpmDataBean;
    if (response.data != null && response.data.salesOrder != null) {
      let salesOrderData = response.data.salesOrder;
      if (!isEmpty(salesOrderData)) {
        cpmDataBean.salesOrderNumber = salesOrderData.code;
        this.setState({
          cpmDataBean: cpmDataBean,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  readandsetSalesOrderDetail = (salesOrderNumber) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = salesOrderNumber;
    input.isLoadChildren = true;
    SalesOrderService.readSalesOrder(
      input,
      this.readandsetSalesOrderDetailResponse,
      this.errorCallBack
    );
  };
  readSalesOrderBySearchString(searchString) {
    let searchCriteria = new SalesOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.salesOrderNumberStartsWith = searchString;
    searchCriteria.salesOrderNumberContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestSalesOrderListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    SalesOrderService.getSalesOrderPageList(
      input,
      this.readBySalesOrderCodeResponse,
      this.errorCallBack
    );
  }
  readBySalesOrderCodeResponse = (response) => {
    let salesOrderNumberData = response.data.salesOrderPageList.salesOrders;
    let simpleAutoCompleteList = new Array();
    if (salesOrderNumberData.length > 0 && salesOrderNumberData != null) {
      salesOrderNumberData.map((salesOrderNumber) => {
        let simpleItemBean = {
          code: salesOrderNumber.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      salesOrderListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  salesOrderEnterKeyEventHandler = (e) => {
    let salesOrderNumber = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading ...",
    });
    this.readandsetSalesOrderDetail(salesOrderNumber);
    this.setState({
      salesOrderListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesOrderList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesOrderList: showAutoCompleteList });
  };

  onPickTicketChange = (e) => {
    let pickTicketNumber = e.target.value;
    this.state.showAutoCompletePTList = true;
    let cpmDataBean = this.state.cpmDataBean;
    let showAutoCompleteList = this.state.showAutoCompletePTList;
    if (isEmpty(pickTicketNumber)) {
      this.state.showAutoCompletePTList = false;
      let showAutoCompleteList = this.state.showAutoCompletePTList;
      let cpmDataBean = this.state.cpmDataBean;
      cpmDataBean.pickTicketNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePTList: showAutoCompleteList,
        cpmDataBean: cpmDataBean,
        pickTicketPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "pickTicketNumber" &&
      showAutoCompleteList == true &&
      pickTicketNumber !== ""
    ) {
      this.loadPickTicketBySearchString(e.target.value);
    }
    cpmDataBean[e.target.name] = e.target.value;
    this.setState({ cpmDataBean: cpmDataBean });
  };
  loadPickTicketDetail = (pickTicketNumber) => {
    let listrequest = new RestReadRequest();
    listrequest.companyCode = this.companyCode;
    listrequest.code = pickTicketNumber;
    PickTicketService.readPickTicket(
      listrequest,
      this.loadPickTicketResponse,
      this.errorCallBack
    );
  };
  loadPickTicketResponse = (response) => {
    let cpmDataBean = this.state.cpmDataBean;
    if (response.data != null && response.data.pickTicket != null) {
      let pickTicket = response.data.pickTicket;
      cpmDataBean.pickTicketNumber = pickTicket.code;
      let showAutoCompletePTList = false;
      this.setState({
        cpmDataBean: cpmDataBean,
        showAutoCompletePTList: showAutoCompletePTList,
      });
    }
  };
  loadPickTicketBySearchString(searchString) {
    let searchCriteria = new PickTicketSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.pickTicketStartsWith = searchString;
    searchCriteria.pickTicketContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestPickTicketListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    PickTicketService.getPickTicketPageList(
      input,
      this.loadByPickTicketResponse,
      this.errorCallBack
    );
  }
  loadByPickTicketResponse = (response) => {
    let pickTicketData = response.data.pickTicketPageList.pickTickets;
    let simpleAutoCompleteList = new Array();
    if (pickTicketData.length > 0 && pickTicketData != null) {
      pickTicketData.map((pickTicket) => {
        let simpleItemBean = {
          code: pickTicket.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      pickTicketPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  PickTicketEnterKeyEventHandler = (e) => {
    let pickTicket = e.target.value;
    this.loadPickTicketDetail(pickTicket);
    this.setState({
      pickTicketPageListForAutoCompleteList: new Array(),
    });
  };

  displayAutoCompletePickTicketList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePTList: showAutoCompleteList });
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isLoading: false,
      loadingText: "",
    });
  };
  logisticOrderOnChange = (e) => {
    let inBoundOrderNumber = e.target.value;
    this.state.showAutoCompleteLogisticOrderNumberList = true;
    let tempCriteria = this.state.cpmDataBean;
    let showAutoCompleteList = this.state.showAutoCompleteLogisticOrderNumberList;
    if (isEmpty(inBoundOrderNumber)) {
      this.state.showAutoCompleteLogisticOrderNumberList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLogisticOrderNumberList;
      let cpmDataBean = this.state.cpmDataBean;
      cpmDataBean.inBoundOrderNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLogisticOrderNumberList: showAutoCompleteList,
        cpmDataBean: cpmDataBean,
        logisticOrderNumberListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "inBoundOrderNumber" &&
      showAutoCompleteList === true &&
      inBoundOrderNumber !== ""
    ) {
      this.readLogisticOrderBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ cpmDataBean: tempCriteria });
  };
  readandsetLogisticOrderDetailResponse = (response) => {
    let cpmDataBean = this.state.cpmDataBean;
    if (response.data != null && response.data.logisticOrder != null) {
      let logisticOrderData = response.data.logisticOrder;
      if (!isEmpty(logisticOrderData)) {
        cpmDataBean.inBoundOrderNumber = logisticOrderData.code;
        this.setState({
          cpmDataBean: cpmDataBean,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  readandsetLogisticOrderDetail = (inBoundOrderNumber) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = inBoundOrderNumber;
    input.isLoadChildren = true;
    LogisticOrderService.readLogisticOrder(
      input,
      this.readandsetLogisticOrderDetailResponse,
      this.errorCallBack
    );
  };
  readLogisticOrderBySearchString(searchString) {
    let searchCriteria = new LogisticOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.logisticOrderNumberStartsWith = searchString;
    searchCriteria.logisticOrderNumberContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestLogisticOrderListRequest();
    input.pageInput = pageList;
    input.criteria = searchCriteria;
    LogisticOrderService.getLogisticOrderPageList(
      input,
      this.readByLogisticOrderResponse,
      this.errorCallBack
    );
  }
  readByLogisticOrderResponse = (response) => {
    let logisticOrderNumberData = response.data.logisticOrderPageList.logisticOrders;
    let simpleAutoCompleteList = new Array();
    if (logisticOrderNumberData.length > 0 && logisticOrderNumberData != null) {
      logisticOrderNumberData.map((inBoundOrderNumber) => {
        let simpleItemBean = {
          code: inBoundOrderNumber.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      logisticOrderNumberListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  logisticOrderEnterKeyEventHandler = (e) => {
    let inBoundOrderNumber = e.target.value;
    // this.setState({
    //   isShowProgressBarPopup: true,
    //   progressLoadingText: "Loading ...",
    // });
    this.readandsetLogisticOrderDetail(inBoundOrderNumber);
    this.setState({
      logisticOrderNumberListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLogisticOrderList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLogisticOrderNumberList: showAutoCompleteList });
  };



  logisticOrderReceiptOnChange = (e) => {
    let inBoundOrderReceiptNumber = e.target.value;
    this.state.showAutoCompleteLogisticOrderReceiptNumberList = true;
    let tempCriteria = this.state.cpmDataBean;
    let showAutoCompleteList = this.state.showAutoCompleteLogisticOrderReceiptNumberList;
    if (isEmpty(inBoundOrderReceiptNumber)) {
      this.state.showAutoCompleteLogisticOrderReceiptNumberList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLogisticOrderReceiptNumberList;
      let cpmDataBean = this.state.cpmDataBean;
      cpmDataBean.inBoundOrderReceiptNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLogisticOrderReceiptNumberList: showAutoCompleteList,
        cpmDataBean: cpmDataBean,
        logisticReceiptOrderListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "inBoundOrderReceiptNumber" &&
      showAutoCompleteList === true &&
      inBoundOrderReceiptNumber !== ""
    ) {
      this.readLogisticIrderReceiptBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ cpmDataBean: tempCriteria });
  };
  readandSetLogisticReceiptDetailResponse = (response) => {
    let cpmDataBean = this.state.cpmDataBean;
    if (response.data != null && response.data.logisticOrderReceipt != null) {
      let receiptData = response.data.logisticOrderReceipt;
      if (!isEmpty(receiptData)) {
        cpmDataBean.inBoundOrderReceiptNumber = receiptData.code;
        this.setState({
          cpmDataBean: cpmDataBean,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  readandsetLogisticOrderReceiptDetail = (inBoundOrderReceiptNumber) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = inBoundOrderReceiptNumber;
    input.isLoadChildren = true;
    LogisticOrderReceiptService.readLogisticOrderReceipt(
      input,
      this.readandSetLogisticReceiptDetailResponse,
      this.errorCallBack
    );
  };
  readLogisticIrderReceiptBySearchString(searchString) {
    let searchCriteria = new LogisticOrderReceiptSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.logisticOrderReceiptNumberStartsWith = searchString;
    searchCriteria.logisticOrderReceiptNumberContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestLogisticOrderReceiptListRequest();
    input.pageInput = pageList;
    input.criteria = searchCriteria;
    LogisticOrderReceiptService.getLogisticOrderReceiptPageList(
      input,
      this.readByLogisticOrderReceiptResponse,
      this.errorCallBack
    );
  }
  readByLogisticOrderReceiptResponse = (response) => {
    let logisticOrderReceiptNumberData = response.data.logisticOrderReceiptPageList.logisticOrderReceipts;
    let simpleAutoCompleteList = new Array();
    if (logisticOrderReceiptNumberData.length > 0 && logisticOrderReceiptNumberData != null) {
      logisticOrderReceiptNumberData.map((inBoundOrderReceiptNumber) => {
        let simpleItemBean = {
          code: inBoundOrderReceiptNumber.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      logisticReceiptOrderListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  logisticReceiptOrderEnterKeyEventHandler = (e) => {
    let inBoundOrderReceiptNumber = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading ...",
    });
    this.readandsetLogisticOrderReceiptDetail(inBoundOrderReceiptNumber);
    this.setState({
      logisticReceiptOrderListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLogisticOrderReceiptList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLogisticOrderReceiptNumberList: showAutoCompleteList });
  };
  save = () => {
    this.saveCpm();
    // this.approveCpm();
  }
  validateCpmData = (cpmBean) => {
    let isValidData = false;
    let err_list = [];
    let errorMessage = "";
    // if (cpmBean == null) {
    //   let errMsg = "Enter All Fields ";
    //   errorMessage = errorMessage + errMsg;
    //   err_list.push(errMsg);
    // } else {
      if (isEmptyString(cpmBean.customerCode)) {
        let errMsg = "Customer is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(cpmBean.containerNumber)) {
        let errMsg = "container is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      // if (isEmptyArray(cpmBean.lines) || cpmBean.lines == null) {
      //   let errMsg = "No purchaseOrder Lines";
      //   errorMessage = errorMessage + errMsg;
      //   err_list.push(errMsg);
      // }
      if (isEmpty(cpmBean.templateCode)) {
        let errMsg = "TemplateCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      // if (isEmpty(poBean.orderType) && this.state.isShowOrderType) {
      //   let errMsg = "PO OrderType is Required";
      //   errorMessage = errorMessage + errMsg;
      //   err_list.push(errMsg);
      // }
    //}
    if (err_list.length > 0) {
      isValidData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidData;
  };
  saveCpm = () => {
    this.setState({
      isLoading: true,
      loadingText: "Saving ..",
    });
    let cpmBean = this.state.cpmDataBean;
    let cpmCreateRequest = new RestCriticalPathManagementOperationRequest();
    cpmCreateRequest.cpmBean = cpmBean;
    let isValidData = false;
    isValidData = this.validateCpmData(cpmBean); 
    if (isValidData){
      if (cpmBean.isFetched) {
        if (
          cpmBean.cpmStatus == LogicConstants.CRITICAL_PATH_MANAGEMENT_OPEN_STATUS
        ) {
          if (
            SecurityAccessManager.CriticalPathManagementUpdation_IsAccessible()
          ) {
            CPMRestService.updateCriticalPathManagement(
              cpmBean,
              this.saveCpmResponse,
              this.errorCallBack
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        }

      } else {
        if (
          SecurityAccessManager.CriticalPathManagementCreation_IsAccessible()
        ) {
          CPMRestService.createCriticalPathManagement(
            cpmCreateRequest,
            this.saveCpmResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    } else {
      this.setState({
        isLoading: false,
        loadingText: "",
      });
    }
  }
  saveCpmResponse = (response) => {
    
    this.setState({ isLoading: false });
    this.handleResponse(response.data);
    if (response.data != null && response.data.cpmBean != null) {
      const cpmBean = response.data.cpmBean;
      if (response.data.success == true) {
        if (cpmBean != null) {
          let pageTitle = this.moduleCaption + " - EDIT";
          this.setState({
            cpmDataBean: cpmBean,
            pageTitle: pageTitle,
            isLoading: false,
            loadingText: "",
          });
          if (!this.isLocked) {
            this.editCpm(response.data.cpmBean.code);
          } else {
            this.code = cpmBean.code;
            this.unlockCpm(cpmBean.code);
          }
        }
      }
    }
  }
  clearError = () => {
    this.setState({ error_list: [] });
  }
  onChange = (e) => {
    let criteria = this.state.cpmDataBean;
    criteria[e.target.name] = e.target.value;
    this.setState({ cpmDataBean: criteria });
  };
  unlockCpm = (code) => {
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = code;
    if (SecurityAccessManager.CriticalPathManagementMaintainance_IsAccessible()) {
      CPMRestService.unLockCriticalPathManagementCode(
        request,
        this.unlockCpmResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }
  unlockCpmResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editCpm(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  }
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  approveCpm = (e) => {
    // if (e.detail == 1) {
    this.setState({
      isLoading: true,
      loadingText: "Approving Purchase Order",
    });
    let cpmBean = this.state.cpmDataBean;
    let input = new RestCriticalPathManagementOperationRequest();
    input.cpmBean = cpmBean;
    if (cpmBean.isFetched) {
      input.isLockReleaseRequired = true;
    } else {
      input.isLockReleaseRequired = false;
    }
    // if (isValidData) {
    if (cpmBean.isFetched) {
      if (
        SecurityAccessManager.CriticalPathManagementApprove_IsAccessible()
      ) {
        CPMRestService.updateAndApproveCriticalPathManagement(
          input,
          this.approveCpmResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.CriticalPathManagementApprove_IsAccessible()
      ) {
        CPMRestService.createAndApproveCriticalPathManagement(
          input,
          this.approveCpmResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
    // } else {
    //   this.setState({ isLoading: false, loadingText: "" });
    // }
    // }
  }
  approveCpmResponse = (response) => {
    this.setState({ isLoading: false, loadingText: "" });
    let isSuccess = this.handleApproveResponse(response.data);
    if (isSuccess) {
      if (
        !isEmpty(response.data) &&
        !isEmpty(response.data.mainOperationResponse)
      ) {
        let cpmData =
          response.data.mainOperationResponse.cpmBean;
        // if (!this.isLocked) {
        this.editCpm(cpmData.code);
      }
    }
  }
  handleApproveResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.mainOperationResponse)) {
      if (!isEmptyArray(response.mainOperationResponse.errors)) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        success = false;
      }
      if (!isEmptyArray(response.mainOperationResponse.infos)) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );
        success = true;
      }
    }
    if (!isEmpty(response.additionalOperationResponse)) {
      if (!isEmptyArray(response.additionalOperationResponse.errors)) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        success = false;
      }
      if (!isEmptyArray(response.additionalOperationResponse.infos)) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );
        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
      let successMsg = [];
      successMsg.push(msg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(infoMsg)) {
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(errMsg)) {
      let errorMsg = [];
      errorMsg.push(errMsg);
      this.setState({
        alertMessage: errorMsg,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({ error_list: errList });
    return success;
  };
  unApproveCpm = (e) => {
    this.setState({
      isLoading: true,
      loadingText: "UnApproving Cpm",
    });
    let cpmBean = this.state.cpmDataBean;
    let request = new RestCriticalPathManagementOperationRequest();
    request.cpmBean = cpmBean;
    // purchaseRequest.reason = this.state.reasonData;
    if (
      SecurityAccessManager.CriticalPathManagementUnApprove_IsAccessible()
    ) {
      CPMRestService.unApproveCriticalPathManagement(
        request,
        this.unApproveCpmResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });

    }
  }
  unApproveCpmResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    if (!isEmpty(response.data) && !isEmpty(response.data.cpmBean)) {
      const cpmBean = response.data.cpmBean;
      if (cpmBean != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          cpmDataBean: cpmBean,
          pageTitle: pageTitle,

        });
        if (this.isLocked) {
          this.code = cpmBean.code;
          this.unlockCpm(cpmBean.code);
        }
      }
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowAlert: isDisplayed,
    });
  };
  templateCodeOnChange = (e) => {
    let templateCode = e.target.value;
    this.state.showAutoCompleteTemplateList = true;
    let temp_criteria = this.state.cpmDataBean;
    let showAutoCompleteList = this.state.showAutoCompleteTemplateList;
    if (isEmpty(templateCode)) {
      this.state.showAutoCompleteTemplateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteTemplateList;
      let cpmDataBean = this.state.cpmDataBean;
      cpmDataBean.templateCode = "";
      cpmDataBean.cmpLineBean = [];
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        cpmDataBean: cpmDataBean,
        showAutoCompleteTemplateList: suggestion,
        previousValue: "",
      });
    } else if (showAutoCompleteList === true && templateCode !== "") {
      this.readTemplateCodeBySearchString(templateCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ cpmDataBean: temp_criteria });
    // this.readSalesPerson(templateCode);
  };
  readTemplateCode = (templateCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = templateCode;
    CPMRestService.readCriticalPathManagementTemplate(
      readrestInput,
      this.readCpmTemplateResponseResponse,
      this.errorCallBack
    );
  };
  readCpmTemplateResponseResponse = (response) => {
    if (
      response.data != null &&
      response.data.cpmTemplateBean != null
    ) {
      let cpmListData = [];

      const cpmdata = response.data.cpmTemplateBean;
      let cpmDataBean = { ...this.state.cpmDataBean }
      cpmListData = cpmdata.templateTasks;
      let lineNumber = 1;
      //Sorting based on sequence number before Creating Lines
      if (cpmListData!= null) {
        cpmListData.sort((a,b) => a.taskSequence - b.taskSequence)
      }
      for (const task of cpmListData) {
        let cmpLineBean = new CriticalPathManagementLineBean();
        cmpLineBean.cpmCode = cpmDataBean.code;
        cmpLineBean.companyCode = this.companyCode;
        cmpLineBean.code = task.cpmTemplateCode;
        cmpLineBean.cpmTemplateCode = task.cpmTemplateCode;
        cmpLineBean.endDate = task.endDate;
        cmpLineBean.endTime = task.endTime;
        cmpLineBean.scheduledDate = task.scheduledDate;

        cmpLineBean.scheduledTime = task.scheduledTime;
        cmpLineBean.startDate = task.startDate;

        cmpLineBean.startTime = task.startTime;
        cmpLineBean.taskCode = task.taskCode;
        cmpLineBean.taskName = task.taskName;
        cmpLineBean.cpmLineNumber = lineNumber++;
        cmpLineBean.comments = task.comments;
        cmpLineBean.lineStatus = LogicConstants.CRITICAL_PATH_MANAGEMENT_LINE_OPEN_STATUS;

        cpmDataBean.cmpLineBean.push(cmpLineBean);
      }
      cpmDataBean.templateCode = cpmdata.code;
      this.setState({
        cpmDataBean: cpmDataBean,
        previousValue: cpmdata.code,
      });
    }
  };

  readTemplateCodeBySearchString = (searchString) => {
    let salesPersonData = this.state.templateList;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((sp) => {
        let templateBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(templateBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      templateCodePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  temPlateCodeEnterKeyEventHandler = (e) => {
    let templateCode = e.target.value;
    if (templateCode != this.state.previousValue) {
      this.readTemplateCode(templateCode);
    }
    this.setState({
      templateCodePageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteTemplateCodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteTemplateList: showAutoCompleteList });
  };
  lineDetailPopup = (val, rowData) => {
    let tempData = { ...rowData }
    this.setState({
      cpmLineData: tempData,
      isShowLinePopup: true,

    });
  };
  closeAlertModalCallBackLvl1 = (isShowPopup) => {
    this.setState({
      isShowLinePopup: isShowPopup,
      isShowAlertLvl1: isShowPopup,
      //   isShowItemImagePopup: false,
    });
    this.hideAlertCallBackLvl1();
    // this.clearLineData();
  };
  hideAlertCallBackLvl1 = (msgType, isDisplayed) => {
    this.setState({
      isShowAlertLvl1: false,
    });
  };
  lineOnChange = (e) => {
    let val = e.target.name;
    let criteria = this.state.cpmLineData;
    criteria[e.target.name] = e.target.value;
    this.setState({ cpmLineData: criteria });

  };
  addOrUpdateLine = (e) => {
    if (e.detail === 1) {
      let cpmLineData = {...this.state.cpmLineData};

      let cpmData = this.state.cpmDataBean;

    //  let cpmLineBean = [...cpmData.cmpLineBean];
      if (!isEmptyArray(cpmData.cmpLineBean)) {
        cpmData.cmpLineBean.map((line, i) => {
          if (
            line.cpmLineNumber ==
            cpmLineData.cpmLineNumber
          ) {
            if(!isEmpty(cpmLineData.scheduledDate)) {
              cpmLineData.scheduledDate = cpmLineData.scheduledDate.toString();
            }
            if(!isEmpty(cpmLineData.startDate)) {
              cpmLineData.startDate = cpmLineData.startDate.toString();
            }
            if(!isEmpty(cpmLineData.endDate)) {
              cpmLineData.endDate = cpmLineData.endDate.toString();
            }
            // cpmLineData.scheduledDate = JSON.stringify(cpmLineData.scheduledDate);
            // cpmLineData.startDate = JSON.stringify(cpmLineData.startDate);
            // cpmLineData.endDate = JSON.stringify(cpmLineData.endDate);
            cpmData.cmpLineBean[i] = cpmLineData;
          }
        });
      }
   //   cpmData.cmpLineBean = cpmLineBean;
      this.setState({
        cpmDataBean: cpmData,
        // logisticReceiptLineData: logisticReceiptLineData,
        isShowLinePopup: false,
      });
    }


  }

  cancelCpm = (e) => {
    if (e.detail == 1) {

      let cpmBean = this.state.cpmDataBean;


      let request = new RestCriticalPathManagementOperationRequest();

      request.cpmBean = cpmBean;


      if (
        SecurityAccessManager.CriticalPathManagementCancel_IsAccessible()
      ) {
        CPMRestService.forceCloseCriticalPathManagement(
          request,
          this.saveCpmResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });

      }
    }

  }

  render() {

    let cpmLineData = this.state.cpmLineData;
    let isDisabledFields = this.state.isDisabledFields;
    const textAreaStyle = {
      maxHeight: "100px",
      width: "100%",
      minHeight: "9em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {this.state.isSpecialViewMode == false ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editCpm}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.cpmLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
          isFocusLookup={this.state.isFocusLookup}
        />
        {!this.state.isCpmListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (

            < BaseToolBar
              extend_toolbar={
                <>
                  {/* {this.state.isShowUnApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.unApproveCpm(e)}
                    >
                      UnApprove
                    </Button>
                  )} */}
                  {/* {this.state.isShowApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.approveCpm(e)}
                    >
                      Approve
                    </Button>
                  )} */}
                  {this.state.isShowCancelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.cancelCpm(e)}
                    >
                      Finish
                    </Button>
                  )}
                </>
              }
              save={this.save}
              clearError={this.clearError}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
            />
          )}
        {this.state.isCpmListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <CpmListForm
              {...this.state}
              pageList={this.state.pageList}
              filterCpm={this.filterCpm}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              editCpm={this.editCpm}
              resetCpm={this.resetCpm}
              isLoading={this.state.isLoading}
              searchOnChange={this.searchOnChange}
            />
          )}


        {this.state.isCpmEntryFormOpen && (
          <CpmEntryForm
            {...this.state}
            onChange={this.onChange}
            onCustomerCodeChange={this.onCustomerCodeChange}
            customerCodeEnterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
            displayAutoCustomerCompleteList={this.displayAutoCustomerCompleteList}

            salesOrderOnChange={this.salesOrderOnChange}
            salesOrderEnterKeyEventHandler={this.salesOrderEnterKeyEventHandler}
            displayAutoCompleteSalesOrderList={this.displayAutoCompleteSalesOrderList}


            onPickTicketChange={this.onPickTicketChange}
            PickTicketEnterKeyEventHandler={this.PickTicketEnterKeyEventHandler}
            displayAutoCompletePickTicketList={this.displayAutoCompletePickTicketList}

            logisticOrderOnChange={this.logisticOrderOnChange}
            logisticOrderEnterKeyEventHandler={this.logisticOrderEnterKeyEventHandler}
            displayAutoCompleteLogisticOrderList={this.displayAutoCompleteLogisticOrderList}


            logisticOrderReceiptOnChange={this.logisticOrderReceiptOnChange}
            logisticReceiptOrderEnterKeyEventHandler={this.logisticReceiptOrderEnterKeyEventHandler}
            displayAutoCompleteLogisticOrderReceiptList={this.displayAutoCompleteLogisticOrderReceiptList}



            templateCodeOnChange={this.templateCodeOnChange}
            temPlateCodeEnterKeyEventHandler={this.temPlateCodeEnterKeyEventHandler}
            displayAutoCompleteTemplateCodeList={this.displayAutoCompleteTemplateCodeList}
            lineDetailPopup={this.lineDetailPopup}
          />
        )}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowLinePopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel2"}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl1}
          title={"LINE DETAIL"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl1}
              hideAlertCallBack={this.hideAlertCallBackLvl1}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons"
                size="sm"
                onClick={(e) => this.addOrUpdateLine(e)}
                disabled={this.state.isDisabledFields}
              >
                Add/Update
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col sm="1">
                  <FormLabel>CPM#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={cpmLineData.cpmCode}
                    onChange={this.lineOnChange}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Line#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={cpmLineData.cpmLineNumber}
                    onChange={this.lineOnChange}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>CpmTemplate#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={cpmLineData.cpmTemplateCode}
                    onChange={this.lineOnChange}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>TaskStatus#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={ModuleUtils.getCpmLineStatusCaption(cpmLineData.lineStatus)}
                    onChange={this.lineOnChange}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>Task</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={cpmLineData.taskCode}
                    onChange={this.lineOnChange}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>TaskName</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={cpmLineData.taskCode}
                    onChange={this.lineOnChange}
                    disabled={true}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel>ScheduleDate</FormLabel>
                </Col>
                <Col sm="2">
                  <DatePickerComponent_adv
                    name={"scheduledDate"}
                    value={cpmLineData.scheduledDate}
                    onChange={this.lineOnChange}
                    disabled={isDisabledFields}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>scheduledTime</FormLabel>
                </Col>
                <Col sm="2">
                  <TimePickerComponent
                    name={"scheduledTime"}
                    type="time"
                    value={cpmLineData.scheduledTime}
                    //  value={ModuleUtils.geTimeFormat(cpmLineData.scheduledTime)}
                    onChange={this.lineOnChange}
                    disabled={isDisabledFields}
                    //enterKeyEventHandler={this.getScheduleTime}
                    format="HH:mm"
                  />
                </Col>

              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>StartDate</FormLabel>
                </Col>
                <Col sm="2">
                  <DatePickerComponent_adv
                    name={"startDate"}
                    value={cpmLineData.startDate}
                    onChange={this.lineOnChange}
                    disabled={isDisabledFields}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>StartTime</FormLabel>
                </Col>
                <Col sm="2">
                  <TimePickerComponent
                    name={"startTime"}
                    type="time"
                    value={cpmLineData.startTime}
                    onChange={this.lineOnChange}
                    disabled={isDisabledFields}
                    format="HH:mm"
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>EndDate</FormLabel>
                </Col>
                <Col sm="2">
                  <DatePickerComponent_adv
                    name={"endDate"}
                    value={cpmLineData.endDate}
                    onChange={this.lineOnChange}
                    disabled={isDisabledFields}

                  />
                </Col>
                <Col sm="1">
                  <FormLabel>EndTime</FormLabel>
                </Col>
                <Col sm="2">
                  <TimePickerComponent
                    name={"endTime"}
                    type="time"
                    value={cpmLineData.endTime}
                    onChange={this.lineOnChange}
                    disabled={isDisabledFields}
                    format="HH:mm"
                  />
                </Col>
              </Row>
              <Row>

                <Col sm="1">
                  <FormLabel>Comments</FormLabel>
                </Col>
                <Col sm="11">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    type="text"
                    name="comments"
                    value={cpmLineData.comments}
                    disabled={isDisabledFields}
                    onChange={this.lineOnChange}
                  />
                </Col>
              </Row>
            </div>
          }
        />
      </div>
    );
  }
}

class CpmEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
    };
    this.templateRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  lineDetailPopup = (e, val, rowData) => {
    this.props.lineDetailPopup(val, rowData);
  }
  cpmTaskListColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Ln#", "cpmLineNumber", true)
        .setStyleDetails("left", "1", "1", "wt-1", "wt-1")
        .setClickDetails(true, false, this.lineDetailPopup, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Task", "taskCode", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Schedule_Date", "scheduledDate", true,false,true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Schedule_Time", "scheduledTime", true,)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Start_Date", "startDate", true,false,true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Start_Time", "startTime", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("End_Date", "endDate", true,false,true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("End_Time", "endTime", true)
        .setStyleDetails("left", "2", "2", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Comments", "comments", true)
        .setStyleDetails("left", "4", "4", "wt-6", "wt-6")
    );
    return columns;
  }
  onCustomerCodeChange = (e) => {
    this.props.onCustomerCodeChange(e);
  };

  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };

  displayAutoCustomerCompleteList = (e) => {
    this.props.displayAutoCustomerCompleteList(e);
  };


  salesOrderOnChange = (e) => {
    this.props.salesOrderOnChange(e);
  };

  salesOrderEnterKeyEventHandler = (e) => {
    this.props.salesOrderEnterKeyEventHandler(e);
  };

  displayAutoCompleteSalesOrderList = (e) => {
    this.props.displayAutoCompleteSalesOrderList(e);
  };


  onPickTicketChange = (e) => {
    this.props.onPickTicketChange(e);
  };

  PickTicketEnterKeyEventHandler = (e) => {
    this.props.PickTicketEnterKeyEventHandler(e);
  };

  displayAutoCompletePickTicketList = (e) => {
    this.props.displayAutoCompletePickTicketList(e);
  };


  logisticOrderOnChange = (e) => {
    this.props.logisticOrderOnChange(e);
  };

  logisticOrderEnterKeyEventHandler = (e) => {
    this.props.logisticOrderEnterKeyEventHandler(e);
  };

  displayAutoCompleteLogisticOrderList = (e) => {
    this.props.displayAutoCompleteLogisticOrderList(e);
  };


  logisticOrderReceiptOnChange = (e) => {
    this.props.logisticOrderReceiptOnChange(e);
  };

  logisticReceiptOrderEnterKeyEventHandler = (e) => {
    this.props.logisticReceiptOrderEnterKeyEventHandler(e);
  };

  displayAutoCompleteLogisticOrderReceiptList = (e) => {
    this.props.displayAutoCompleteLogisticOrderReceiptList(e);
  };


  templateCodeOnChange = (e) => {
    this.props.templateCodeOnChange(e);
  };

  temPlateCodeEnterKeyEventHandler = (e) => {
    this.props.temPlateCodeEnterKeyEventHandler(e);
  };

  displayAutoCompleteTemplateCodeList = (e) => {
    this.props.displayAutoCompleteTemplateCodeList(e);
  };
  render() {
    let cpmDataBean = this.props.cpmDataBean;
    let isDisabledFields = this.props.isDisabledFields;
    let cpmList = [];
    if (!isEmptyArray(cpmDataBean.cmpLineBean)) {
      cpmList = cpmDataBean.cmpLineBean;
    }
    let is3PL = this.props.is3PL;
    return (
      <div>
        <div >
          <Row>
            <Col sm="1">
              <FormLabel>CPM Code</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                value={cpmDataBean.code}
                onChange={this.onChange}
                isMandatory={true}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Customer</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCustomerCodeChange}
                disabled={isDisabledFields}
                name="customerCode"
                placeholder="Customer"
                value={cpmDataBean.customerCode}
                lookupRequired={true}
                lookupHandler={this.props.customerLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                autoCompleteListData={this.props.customerPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCustomerCompleteList}
                showAutoCompleteList={this.props.showAutoCompleteCustomerList}
                isMandatory={true}
              />
            </Col>
            <Col sm="3">
              <InputTextbox
                disabled={true}
                name="customerName"
                value={cpmDataBean.customerName}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Date</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <DatePickerComponent_adv
                name="cpmDate"
                value={cpmDataBean.cpmDate}
                onChange={this.onChange}
                disabled={isDisabledFields}
                isMandatory={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Container#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="containerNumber"
                value={cpmDataBean.containerNumber}
                onChange={this.onChange}
                isMandatory={true}
                disabled={isDisabledFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>WH PO#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="warehousePurchaseOrderNumber"
                value={cpmDataBean.warehousePurchaseOrderNumber}
                onChange={this.onChange}
                disabled={isDisabledFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Template</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.templateRef}
                name="templateCode"
                onChange={this.templateCodeOnChange}
                value={cpmDataBean.templateCode}
                lookupRequired={true}
                lookupHandler={this.props.templateLookUpHandle}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.temPlateCodeEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.templateCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteTemplateCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteTemplateList
                }
                disabled={isDisabledFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Status</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="cpmStatus"
                value={ModuleUtils.getCpmStatusCaption(cpmDataBean.cpmStatus)}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Sales</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.salesOrderOnChange}
                disabled={isDisabledFields}
                name="salesOrderNumber"
                placeholder="salesOrderNumber"
                value={cpmDataBean.salesOrderNumber}
                lookupRequired={true}
                lookupHandler={this.props.salesOrderLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.salesOrderEnterKeyEventHandler}
                autoCompleteListData={this.props.salesOrderListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteSalesOrderList}
                showAutoCompleteList={this.props.showAutoCompleteSalesOrderList}
              />
            </Col>
            <Col sm="1">
              <FormLabel>PickTicket</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onPickTicketChange}
                disabled={isDisabledFields}
                name="pickTicketNumber"
                placeholder="pickTicketNumber"
                value={cpmDataBean.pickTicketNumber}
                lookupRequired={true}
                lookupHandler={this.props.pickTicketLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.PickTicketEnterKeyEventHandler}
                autoCompleteListData={this.props.pickTicketPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompletePickTicketList}
                showAutoCompleteList={this.props.showAutoCompletePTList}
              />
            </Col>
            {is3PL ? (
              <Col sm="1">
                <FormLabel>Inbound#</FormLabel>{" "}
              </Col>
            ) : null}
            {is3PL ? (
              <Col sm="2">
                <InputTextbox
                  onChange={this.logisticOrderOnChange}
                  name="inBoundOrderNumber"
                  placeholder="inBoundOrderNumber"
                  value={cpmDataBean.inBoundOrderNumber}
                  lookupRequired={true}
                  lookupHandler={this.props.logisticOrderLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.logisticOrderEnterKeyEventHandler}
                  autoCompleteListData={this.props.logisticOrderNumberListForAutoCompleteList}
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteLogisticOrderList}
                  disabled={isDisabledFields}
                  showAutoCompleteList={this.props.showAutoCompleteLogisticOrderNumberList}

                />
              </Col>
            ) : null}
            {is3PL ? (
              <Col sm="1">
                <FormLabel>InboundReceipt#</FormLabel>{" "}
              </Col>
            ) : null}
            {is3PL ? (
              <Col sm="2">
                <InputTextbox
                  onChange={this.logisticOrderReceiptOnChange}
                  name="inBoundOrderReceiptNumber"
                  placeholder="inBoundOrderReceiptNumber"
                  value={cpmDataBean.inBoundOrderReceiptNumber}
                  lookupRequired={true}
                  lookupHandler={this.props.logisticReceiptLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.logisticReceiptOrderEnterKeyEventHandler}
                  autoCompleteListData={this.props.logisticReceiptOrderListForAutoCompleteList}
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteLogisticOrderReceiptList}
                  showAutoCompleteList={this.props.showAutoCompleteLogisticOrderReceiptNumberList}
                  disabled={isDisabledFields}

                />
              </Col>
            ) : null}
          </Row>
        </div>

        <div className="mt-3">
          <CustomTable
            data={cpmList}
            columns={this.cpmTaskListColumns()}
          />
        </div>


      </div>

    );
  }
}
class CpmListForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      // criteria: new PurchaseOrderSearchCriteria(),
      pageList: this.props.pageList,
    };
    this.searchRef = React.createRef();
  }
  // componentDidMount() {
  //   const { appData } = this.context;
  //   this.companyCode = appData.companyCode;
  //   //  this.initLookupHandlers();
  // }
  // componentDidMount() {
  //   if (this.searchRef.current != null) {
  //     this.searchRef.current.focus();
  //   }
  // }
  searchOnChange = (e) => {
    this.props.searchOnChange(e);
  };
  filterCpm = (e) => {
    if (e.detail == 1) this.props.filterCpm();
  };
  resetCpm = (e) => {
    let criteria = this.props.criteria;
    if (e.detail == 1) this.props.resetCpm(criteria);
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  editCpm = (e, val, rowData) => {
    if (e.detail == 1) this.props.editCpm(val);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterCpm();
    }
  };
  cpmListColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("CPM Code", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.editCpm, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Template", "templateCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ContainerNumber", "containerNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CPMStatus", "cpmStatus", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getCaption)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CreatedDate", "createdDate", true,false,true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    return columns;
  }
  getCaption = (status) => {
    return ModuleUtils.getCpmStatusCaption(status);
  };
  render() {
    let pageList = this.props.pageList;
    let totalPages = 0;
    if (!isEmpty(pageList)) {
      let pageSize = pageList.pageSize;
      let totalCount = pageList.totalCount;
      totalPages = totalCount / pageSize;
      totalPages += totalCount % pageSize == 0 ? 0 : 1;
    }
    let cpmListData = this.props.cpmListData;
    let criteria = this.props.criteria;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="mdle-criteria-wrap">

          <div className="">
              <FormLabel className="criteria-labl">Status</FormLabel>
            </div>
            <div className="criteria-val">
              <FormControl
                as="select"
                custom
                onChange={this.searchOnChange}
                name="cpmStatus"
                value={criteria.cpmStatus}
              >
                <option value={""}>All</option>
                <option value={"O"}>Open</option>
                <option value={"F"}>Finished</option>
              </FormControl>
            </div>
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="searchName"
                type="text"
                value={criteria.searchName}
                placeholder="Enter Value to Filter.."
                onChange={this.searchOnChange}
                onKeyDown={this.onKeyDown}
              />
              <Button onClick={(e) => this.filterCpm(e)}>
                Filter
              </Button>
              <Button onClick={(e) => this.resetCpm(e)}>
                Reset
              </Button>
            </span>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="mt-3">
          <CustomTable
            data={cpmListData}
            columns={this.cpmListColumns()}
          />
        </div>

      </div>
    );
  }
}
class CpmEntryMaintenanceModule extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div id="moduleContainer" className="module_container">
        <div className="App">
          <Cpm {...this.props} name="" />
          <br />
        </div>
      </div>
    );
  }
}

export default CpmEntryMaintenanceModule;
